import * as React from 'react'

import { Box, CardInfo, Text } from '@factorialco/deprecated-design-system'
import { CustomTablesListPermissionsPageDocument } from 'generated/resources/graphql'
import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'
import sortBy from 'lodash/sortBy'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import List from './_List'

interface Props {
  schemas: EmployeeCustomTablesSchemaFragment[]
  attachableId: string
}

const CustomTablesList = ({ schemas, attachableId }: Props) => {
  const { data, loading } = useQuery(CustomTablesListPermissionsPageDocument, {
    variables: {
      employeeId: attachableId,
    },
  })

  const canManage = data?.employees._policies.manageCustomTableSettings.can ?? false
  const currency = data?.employees?.employee?.legalEntity?.currency ?? ''
  const canAddCustomTableRecords =
    data?.employees.employee?._policies?.addCustomTablesRecords.can ?? false

  const refs = schemas.map(() => React.createRef<HTMLElement>())

  const sortedSchemas = sortBy(schemas, (schema) => schema.position)

  if (loading) return <Loading />

  return (
    <Box flexGrow flexDirection="column" paddingY="s32" paddingRight="s48">
      {sortedSchemas.length > 0 && (
        <List
          schemas={sortedSchemas}
          attachableId={attachableId}
          schemaRefs={refs}
          currency={currency}
          canManage={canManage}
          canAddValues={canAddCustomTableRecords}
        />
      )}
      {sortedSchemas.length === 0 && (
        <CardInfo>
          <Box flexDirection="row" justifyContent="center" flexGrow>
            <Text.Normal>{i18n.t('custom_tables.none')}</Text.Normal>
          </Box>
        </CardInfo>
      )}
    </Box>
  )
}

export default CustomTablesList
